/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useEffect, useState } from "react";
import "../../../assets/styles/custom-style.css";
import { useAuth } from "../../../auth";
import { enableStatus, listCouponData,getCategory,getCuisine } from "../core/_requests";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../../component/Pagination";
import { useFormattedUtils } from "../../../component/dateUtils";
import SearchInput from "../../../component/core/Searchinput";
interface Coupon {
  primaryId: any;
  amount?: number;
  name?: string;
  startDate?: string;
  minimumOrderValue?: string;
  usagePerUse?: string;
  limit?: string;
  endDate?: string;
  usagePerUser?: string;
  enableDisableStatus?: boolean;
  categoryId?: string;
  cuisineId?: string;
}

const ListCoupon = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { formatDateUS } = useFormattedUtils();
  const [listCoupon, setListCoupon] = useState<Coupon[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const chefId = currentUser?.uuid;
  const [categories, setCategories] = useState<any[]>([]);
const [cuisines, setCuisines] = useState<any[]>([]);

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dataSearch = searchParams.get("search");
  // useEffect to set the search term from URL (or local storage if needed)
  useEffect(() => {
;
    if (dataSearch !== null) {
      setSearch(dataSearch);
    }
  }, [dataSearch]);
  const filterData = {
    search: dataSearch,
  };
  useEffect(() => {
    listCouponData(chefId, filterData).then((res) => {
      setListCoupon(res?.data);
            setLoading(false);
    });
  }, []);

  const AddCoupon = () => {
    navigate("/coupon/add");
  };

  const deleteCoupon = (primaryId: string) => {
    navigate("/coupon/delete/" + primaryId);
  };

  const editCoupon = (primaryId: string) => {
    navigate("/coupon/edit/" + primaryId);
  };

  const clickApply = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setCurrentPage(1);
    const data = {
      search: search,
    };
    try {
      const res = await listCouponData(chefId, data).then((res) => {
        setListCoupon(res?.data);
        setLoading(false);
      });
    } catch (error) {
      console.error("Error fetching coupon:", error);
      setLoading(false);
    }
  };
useEffect(() => {
  getCategory().then((res) => {
    setCategories(res?.data?.data || []);
  });

  getCuisine().then((res) => {
    setCuisines(res?.data?.data || []);
  });
}, []);

  const clickCancel = () => {
    navigate("/coupon");
  };
  const handleEnableDisable = (id: any, status: any) => {
    const enableDisable = !status; // Toggle the status
    const data = { enableDisableStatus: enableDisable };
    enableStatus(id, data).then((res) => {
      const updatedListCoupon = listCoupon.map((item) => {
        if (item.primaryId === id) {
          return { ...item, enableDisableStatus: enableDisable };
        }
        return item;
      });
      setListCoupon(updatedListCoupon);
    });
  };
  //pagination

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = listCoupon.slice(indexOfFirstItem, indexOfLastItem);
  const pages = Math.ceil(listCoupon.length / itemsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= pages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    const isActive = number === currentPage;

    let pageNumberContent;

    if (
      number === 1 ||
      number === pages ||
      (number >= currentPage - 1 && number <= currentPage + 1)
    ) {
      pageNumberContent = (
        <li
          key={number}
          className={`page-item ${number === currentPage ? "active" : ""}`}
        >
          <a
            className={`page-link cursorPointer ${
              number === currentPage ? "active" : ""
            }`}
            onClick={() => setCurrentPage(number)}
          >
            {number}
          </a>
        </li>
      );
    } else if (number === 2 || number === pages - 1) {
      // Add links for second and second-to-last pages
      pageNumberContent = (
        <li key={number} className="page-item">
          <a
            className="page-link cursorPointer"
            onClick={() => setCurrentPage(number)}
          >
            {number}
          </a>
        </li>
      );
    } else if (number === 3 && currentPage > 4) {
      // Add ellipsis before the link to the second page
      pageNumberContent = (
        <li key={number} className="page-item">
          <span className="ellipsis">...</span>
        </li>
      );
    } else if (number === pages - 2 && currentPage < pages - 3) {
      // Add ellipsis before the link to the second-to-last page
      pageNumberContent = (
        <li key={number} className="page-item">
          <span className="ellipsis">...</span>
        </li>
      );
    }

    return pageNumberContent;
  });

  const nextPage = () => {
    if (currentPage < pages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const getCategoryName = (id?: string) => {
  if (!id) return "-";
  return categories.find((c) => c.uuid === id)?.name || "-";
};

const getCuisineName = (id?: string) => {
  if (!id) return "-";
  return cuisines.find((c) => c.uuid === id)?.name || "-";
};

  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            {/*  */}
            <section className="row main-content">
              <div className="title mb-3">
                <h3 className="mb-0">Coupon ({listCoupon?.length})</h3>
              </div>
              <div className="col-12 title-btm">
                             <SearchInput
                                 value={search}
                              onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                                  onKeyUp={clickApply}
                                        />
                <button
                  className="btn btn-primary btn-ico rounded-5"
                  onClick={AddCoupon}
                >
                  <i className="material-symbols-outlined">add_circle</i>
                  <span>Add Coupon</span>
                </button>
              </div>

              <div className="table-wrap mt-4">
                <table className="table custom-table">
                  <thead>
                    <tr>
                      <th>Coupon Code</th>
                      <th>Amount ($)</th>
                      <th>Minimum Order</th>
                      <th>Coupon Limit</th>
                      <th>Coupon User</th>
                        <th>Category</th>
    <th>Cuisine</th>
                      <th>Available</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((item, i) => (
                        <tr key={i}>
                          <td>
                            <p className="mb-0">{item?.name}</p>
                          </td>

                          <td>
                            <p className="mb-0">
                              {typeof item.amount === "number"
                                ? item.amount.toFixed(2)
                                : "N/A"}
                            </p>
                          </td>

                          <td>
                            <p className="mb-0">{item?.minimumOrderValue}</p>
                          </td>
                          <td>
                            <p className="mb-0">{item?.limit}</p>
                          </td>
                          <td> {item?.usagePerUser}</td>
       <td>{getCategoryName(item?.categoryId)}</td>
<td>{getCuisineName(item?.cuisineId)}</td>

                          <td>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input cursorPointer"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                checked={item?.enableDisableStatus}
                                onClick={() =>
                                  handleEnableDisable(
                                    item?.primaryId,
                                    item?.enableDisableStatus
                                  )
                                }
                              />
                              <label className="yes">Yes</label>
                              <label className="no">No</label>
                            </div>
                          </td>
                          <td>
                            <p className="mb-0">{formatDateUS(item?.startDate)}</p>
                          </td>
                          <td>
                            <p className="mb-0">{formatDateUS(item?.endDate)}</p>
                          </td>
                          <td>
                            <div className="action-item">
                              <a
                                className="success cursorPointer"
                                onClick={() => editCoupon(item?.primaryId)}
                              >
                                <span className="material-symbols-outlined">
                                  edit
                                </span>
                              </a>
                              <a
                                className="danger cursorPointer"
                                onClick={() => deleteCoupon(item?.primaryId)}
                              >
                                <span className="material-symbols-outlined">
                                  delete
                                </span>
                              </a>
                             
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : loading ? (
                      <tr>
                        <td colSpan={9} className="text-center">
                          Loading...{" "}
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td colSpan={9} className="text-center">
                          No data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <Pagination
                data={listCoupon}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
                currentItems={currentItems}
                pages={pages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageNumbers={pageNumbers}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
              />
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default ListCoupon;
